import { render, staticRenderFns } from "./ZJ4361Component.vue?vue&type=template&id=2a4060dc&scoped=true&"
import script from "./ZJ4361Component.vue?vue&type=script&lang=js&"
export * from "./ZJ4361Component.vue?vue&type=script&lang=js&"
import style0 from "./ZJ4361Component.vue?vue&type=style&index=0&id=2a4060dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4060dc",
  null
  
)

export default component.exports